<template>

    <div class="container-center">

        <el-card class="box-card">

            <div slot="header" class="clearfix contract-data-top with-icon">
                <img
                    src="data:image/png;base64,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">
                <p><span class="title">{{ detailData.checkName || '技术核定单发起' }}</span></p>
                <p class="status">
                    <span :title="detailData.approveStatus" v-bind:class="['state-shet'+ detailData.approveStatus]">
                        {{ baseStatus[detailData.approveStatus] }}
                        {{ detailData.nodeName && (`（当前审批节点：${detailData.nodeName}）`) }}
                    </span>
                </p>
                <br><span v-if="detailData.oaRequestId">流程ID：{{ detailData.oaRequestId }}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                <!-- <br>所属合同：{{ decodeURIComponent($route.params.name) }} &nbsp;&nbsp;&nbsp;&nbsp; <span v-if="pageType!=0">发起时间：{{ detailData.createDate }}</span> -->
            </div>


            <!-- 材料列表 -->
            <!-- <label v-if="pageType!=0" class="fade-title">技术核定单编号：{{ detailData.checkNo }}</label> -->

            <div v-if="pageType==0 || detailData.approveStatus==4 || editMode" style="padding-top:20px;">
                <el-form label-width="200px" ref="form" :model="form" :rules="rules" size="mini">
                    <el-row>
                        <el-col :span="12" :offset="6">
                            <el-form-item label="工程图纸编号：" prop="drawingNo">
                                <el-input v-model="form.drawingNo" clearable></el-input>
                            </el-form-item>

                            <!-- <el-form-item label="核定内容：" prop="checkContent">
                                 <el-input v-model="form.checkContent" type="textarea" :rows="4" clearable></el-input>
                             </el-form-item>
 -->
                            <el-form-item
                                v-for="(dhsConContentRecord, index) in form.dhsConContentRecordList"
                                :label="'核定内容' + (index+1)"
                                :key="dhsConContentRecord.key"
                                :prop="'dhsConContentRecordList.' + index + '.content'"
                                :rules="{  required: true, message: '核定内容不能为空', trigger: 'blur'   }"
                            >
                                <div class="com_content_div">
                                    <el-input v-model="dhsConContentRecord.content" type="textarea" 
                                    :maxlength="500"
                                    placeholder="核定内容请不要超过500字"
                                    :rows="4" clearable></el-input>
                                    <div style="margin-left: 5px">
                                        <el-button @click.prevent="removeDomain(dhsConContentRecord)">删除</el-button>
                                    </div>
                                </div>

                            </el-form-item>

                            <el-form-item>
                                <el-button @click="addDomain">新增核定内容</el-button>
                            </el-form-item>


                            <el-form-item label="附件：" prop="">
                                <el-upload
                                    class="upload-demo"
                                    multiple
                                    ref="upload"
                                    :limit="20"
                                    :action="uploadApi"
                                    :file-list="form.baseFileList"
                                    :on-success="handleAdd" :on-error="uploadError"
                                    :before-upload="beforeUpload"
                                    :on-remove="handleRemove"
                                >
                                    <el-button size="small" type="primary">上 传</el-button>
                                    <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                        <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <!-- 详情 -->
            <table v-if="pageType != 0" class="el-table el-table--striped el-table--border mian-table">
                <tr>
                    <td class="table-head">发包单位</td>
                    <td class="table-content">{{ contractInfo.firstPacName || contractInfo.ownerParty }}</td>
                    <td class="table-head">项目名称</td>
                    <td class="table-content">{{ contractInfo.projectname }}</td>
                </tr>
                <tr>
                    <td class="table-head">合同名称</td>
                    <td class="table-content">{{ contractInfo.fname }}</td>
                    <td class="table-head">技术核定单编号</td>
                    <td class="table-content">{{ (pageType!=0 && detailData.checkNo) || '无' }}</td>
                </tr>
                <tr>
                    <td class="table-head">合同编号</td>
                    <td class="table-content">{{ contractInfo.contractBillId }}</td>
                    <td class="table-head">供方名称</td>
                    <td class="table-content">
                        {{ contractInfo.supplierName }}
                    </td>
                </tr>
                <tr>
                    <td class="table-head">工程图纸编号</td>
                    <td colspan="3" class="table-content">
                        {{ detailData.drawingNo || '无' }}
                    </td>
                </tr>
                <tr v-if="detailData.dhsConContentRecordList.length">
                    <td class="table-head-two">序号</td>
                    <td class="table-head-two" colspan="2">申请核定内容</td>
                    <td class="table-head-two">核定意见</td>
                </tr>
                <tr v-for="(one, index) in detailData.dhsConContentRecordList" :key="index">
                    <td class="table-content-tow">{{ index + 1 }}</td>
                    <td colspan="2" class="table-content-tow">{{ one.content || '无' }}</td>
                    <td colspan="2" class="table-content-tow">{{ one.comContent || '无' }}</td>
                </tr>
                <tr>
                    <td class="table-head">上传附件</td>
                    <td colspan="3" class="table-content">
                        <div v-for="li in detailData.baseFileList" :key="li.id" style="padding: 1px 0;">
                            <a :href="downloadApi +'?fileId='+ li.id">{{ li.fileOldName }}</a>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="table-head">单据附件</td>
                    <td colspan="3" class="table-content">
                        <div v-for="li in detailData.easFileList" :key="li.id" style="padding: 1px 0;">
                            <a :href="downloadApi +'?fileId='+ li.id">{{ li.fileOldName }}</a>
                        </div>
                    </td>
                </tr>
            </table>

            <!-- 详情 -->
            <!-- <div v-if="pageType != 0 &&  detailData.approveStatus!=4 && !editMode" class="detail-box">
                <el-row>
                    <el-col :span="5" class="text-right">工程图纸编号：</el-col>
                    <el-col :span="19">{{ form.drawingNo || '无' }}</el-col>
                </el-row>

                <el-row v-if="form.checkContent!=null && form.checkContent!=''">
                    <el-col :span="5" class="text-right">核定内容：</el-col>
                    <el-col :span="19">{{ form.checkContent || '无' }}</el-col>
                </el-row>

                <div v-if="form.checkContent==null || form.checkContent=='' "
                     v-for="(dhsConContentRecord, index) in form.dhsConContentRecordList">


                    <el-row>
                        <el-col :span="5" class="text-right">核定内容{{(index+1)}}：</el-col>
                        <el-col :span="19">{{ dhsConContentRecord.content || '无' }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5" class="text-right">核实核定内容{{(index+1)}}：</el-col>
                        <el-col :span="19">{{ dhsConContentRecord.comContent || '无' }}</el-col>
                    </el-row>

                </div>


                <el-row>
                    <el-col :span="5" class="text-right">附件：</el-col>
                    <el-col :span="19">
                        <div v-if="!form.baseFileList || form.baseFileList && form.baseFileList.length==0"
                             class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in form.baseFileList" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id"
                                                                                target="_blank">{{ li.fileOldName }}</a>
                            </li>
                        </ul>
                    </el-col>
                </el-row>
            </div> -->
            <el-row>
                <el-col :span="12" :offset="6">
                    <div class="text-center" style="padding:30px 0;">
                        <el-button @click="$router.push($root.navs[1].path)" type="" size="medium" icon="el-icon-back">
                            返回合同台账
                        </el-button>
                        <el-button v-if="!editMode && (detailData.approveStatus==0 || detailData.approveStatus==1)" @click="editMode=true"  type="primary" size="medium">修 改</el-button>
                        <el-button v-if="editMode" @click="getDetailData();editMode=false;"  type="primary" size="medium">退出修改</el-button>
                        <el-button v-if="pageType==0" :disabled="submitflag" @click="submit" type="primary" size="medium">提交申请</el-button>
                    </div>
                </el-col>
            </el-row>

            <!-- 分隔线 -->
            <!-- <div v-if="pageType!=0" class="fade-line"></div> -->
            <!-- 单据附件 -->
            <!-- <label class="fade-title">单据附件</label>
            <div v-if="pageType!=0" class="invoices-file">
                <div v-if="!detailData.easFileList || detailData.easFileList && detailData.easFileList.length==0"
                     class="no-data-tip"></div>
                <ul v-else>
                    <li v-for="li in detailData.easFileList" :key="li.id"><a :href="downloadApi +'?fileId='+ li.id"
                                                                             target="_blank">{{ li.fileOldName }}</a>
                    </li>
                </ul>
            </div> -->
            <!-- 分隔线 -->
            <!-- <div v-if="pageType!=0" class="fade-line"></div> -->

            <!-- 审批记录 -->
            <!-- <div v-if="pageType!=0">
                <label class="fade-title">审批记录</label>

                <el-table :data="detailData.approveList||[]" size="mini" border stripe>
                    <el-table-column align="center" width="50" type="index" label="序号"></el-table-column>
                    <el-table-column align="center" width="160" label="发起时间" prop="createDate"></el-table-column>
                    <el-table-column align="center" width="160" label="审批结果" prop="approveStatus">
                        <template slot-scope="scope">
                            <span v-bind:class="'state-shet'+scope.row.approveStatus" :title="scope.row.approveStatus">
                                {{ baseStatus[scope.row.approveStatus] }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="审批意见" prop="approveRemark"></el-table-column>
                    <el-table-column align="center" width="160" label="审批时间" prop="approveDate"></el-table-column>
                </el-table>
            </div> -->
        </el-card>


    </div><!-- container-center -->

</template>

<script>
    import banner from '@/assets/imgs/banner_inviteMng.png'
    // import ElBadge from 'element-ui/packages/badge/src/main'
    import util from '@/util'
    // import ElOption from "element-ui/packages/select/src/option";
    // import ElInput from "element-ui/packages/input/src/input";

    export default {
//    components: {
//        ElInput,
//        ElOption,
//        ElBadge},
        name: 'contract-detail',
        data () {
            return {

                uploadApi: `${util.baseUrl}rest/file/upload`,
                downloadApi: `${util.baseUrl}rest/file/down`,
                baseStatus: ['草稿', '待审批', '审批中', '审批通过', '审批不通过'],

                // 编辑模式
                editMode: false,

                // 表单验证
                rules: {
                    drawingNo: [
                        {required: true, message: '必填'}
                    ],
                    checkContent: [
                        {required: true, message: '必填'}
                    ]
                },

                // 页面类型 0: 发起,带billId;  1: 查看,带msgId
                pageType: this.$route.params.type,

                // 详情数据
                detailData: {
                    dhsConPricingDetailList: [],
                    easFileList: [],
                    dhsConContentRecordList: []
                },

                // 表单
                form: {
                    drawingNo: '',
                    checkContent: '',
                    baseFileList: [],
                    dhsConContentRecordList: [{content: ''}]
                },
                contractInfo: {},
                submitflag: false
            }
        },
        methods: {

            // 上传文件格式验证
            beforeUpload (file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },

            uploadError () {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'})
            },
            addDomain () {
                this.form.dhsConContentRecordList.push({
                    content: ''
                })
            },
            removeDomain (item) {
                var index = this.form.dhsConContentRecordList.indexOf(item)
                if (index !== -1) {
                    this.form.dhsConContentRecordList.splice(index, 1)
                }
            },
            // 提交
            submit () {
                this.submitflag = true
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})

                        this.form.baseFileList =  __getBaseFiles__(null, this.$refs.upload.uploadFiles)
                        if (this.pageType == 0) {  // 发起
                            this.$http.post('rest/api/contract/createCheckBill',
                                Object.assign(
                                    {
                                        contractBillId: this.$route.params.id
                                    },
                                    this.form
                                )
                            ).then((res) => {
                                // loading.close()

                                if (res.data.result) {
                                    this.$message({message: '提交成功', type: 'success'})

                                    // 提交后跳转
                                    this.$router.push('/ContractDetail07/1/' + res.data.value.id + '/' + encodeURIComponent(this.$route.params.name))
                                    setTimeout(function () {
                                        location.reload()
                                    }, 1000)
                                } else {
                                    this.submitflag = false
                                    loading.close()
                                    this.$message({message: `Error: ${res.data.message}`, type: 'error'})
                                }
                            })
                        } else {  // 不通过二次提交
                            // this.$http.post('rest/api/contract/updateCheckBill',
                            //     Object.assign(
                            //         {
                            //             id: this.$route.params.id,
                            //             contractBillId: this.detailData.contractBillId
                            //         },
                            //         this.form
                            //     )
                            // ).then((res)=>{

                            //     loading.close()

                            //     if(res.data.result) {
                            //         this.$message({message: '修改成功', type: 'success'})

                            //         this.getDetailData()
                            //         this.editMode = false
                            //     } else {
                            //         this.$message({message: 'Error: 修改失败', type: 'error'})
                            //     }
                            // })
                        }
                    } else {
                        this.submitflag = false
                        this.$message({message: '材料表单填写有误', type: 'error'})
                        return false
                    }
                })
            },

            // 获取详情
            getDetailData () {
                const loading = this.$loading({background: 'rgba(255,255,255,0.5)'})
                this.$http.post('rest/api/contract/getCheckBillInfo', {
                    msgId: this.$route.params.id
                }).then((res) => {
                    loading.close()
                    if (res.data.result) {
                        this.detailData = res.data.value
                        this.form = res.data.value,
                        this.contractInfo = res.data.value.conContractBill

                        this.form.baseFileList.forEach(function (data) {
                            data.name = data.fileOldName
                        })

                        this.$root.navs = [{
                            name: '合同业务列表',
                            path: '/contractList'
                        }, {
                            name: decodeURIComponent(this.$route.params.name),
                            path: '/contractSheet/' + encodeURIComponent(this.detailData.contractBillId)
                        }, {name: '详情'}]
                    } else {
                        this.$message({message: 'Error: 获取详情', type: 'error'})
                    }
                })
            },

            handleRemove: function (file, fileList) {
                // this.form.baseFileList = this.form.baseFileList.filter(function (f) {
                //     return f.uid !== file.uid
                // })
            },
            handleAdd: function (response, file, fileList) {
                // if(file.status=='success'){
                // this.form.baseFileList = __getBaseFiles__(file, fileList)
                // }
            }

        },
        created () {
            this.$root.headImage.src = banner
            this.$root.activeIndex = 'home'
            this.$root.isPublic = false
            this.$root.navs = []
        },
        mounted () {
            // dev test
            window.ji = this

            // 0: 发起 带billId;  1: 查看 带msgId
            if (this.pageType == 0) {
                this.$root.navs = [{
                    name: '合同业务列表',
                    path: '/contractList'
                }, {
                    name: decodeURIComponent(this.$route.params.name),
                    path: '/contractSheet/' + encodeURIComponent(this.$route.params.id)
                }, {name: '发起'}]
            } else {
                this.getDetailData()
            }

            util.toTop()
        }
    }

    function __getBaseFiles__ (file, fileList) {
        let fs = []
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0]
                item.bizTableName = f.biztablename
                item.bizTablePkName = f.biztablepkname
                item.bizTablePkValue = f.biztablepkvalue
                item.fid = f.fid
                item.fileCatagoryId = f.filecatagoryid
                item.fileDesc = f.filedesc
                item.fileOldName = f.fileoldname
                item.name = f.fileoldname
                item.fileName = f.filename
                item.filePath = f.filepath
                item.fileSize = f.filesize
                item.fileType = f.filetype
                item.sort = f.sort
            }
            fs.push(item)
        })
        console.log(fs)
        return fs
    }
</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';


    a {
        color: var(--cMain);
        cursor: pointer;
    }

    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }

    .box-card {
        margin: 30px 0;
    }


    .fade-title {
        display: inline-block;
        margin-bottom: 20px;
        color: var(--cTxt2);
        font-size: 15px;
        font-weight: bold;
        line-height: 28px;
    }

    .fade-line {
        border-top: 1px dashed #ddd;
        margin: 40px 0;
    }


    .detail-box {
        padding: 20px 120px;
    }

    .detail-box .el-row {
        line-height: 48px;
    }

    .detail-box .text-right {
        color: var(--cTxt3);
    }

    .invoices-file {
        padding-left: 100px;
    }

    .invoices-file li {
        line-height: 48px;
    }

    .com_content_div {
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/contract/vDetail07.vue